import { t } from 'i18next'

import {
  formatSettledDay,
  MetricAlertIcon,
  type MetricAlertProps
} from '../MetricAlertIcon'

export function LostIsBudgetAlertIcon({
  value,
  settledDay,
  loading = false
}: MetricAlertProps) {
  if (loading) return null

  if (value == null) {
    const date = formatSettledDay(settledDay)

    return (
      <MetricAlertIcon
        ariaLabel={t('rm:alerts.lostIsBudgetAlert')}
        text={
          date
            ? t('rm:alerts.impressionShareFamilyConsolidatedUntil', { date })
            : t('rm:alerts.lostIsBudgetUnavailable')
        }
        variant="warning"
        testId="lost-is-budget-icon"
      />
    )
  }

  if (Number(value) === 0) {
    return (
      <MetricAlertIcon
        ariaLabel={t('rm:alerts.lostIsBudgetAlert')}
        text={t('rm:alerts.lostIsBudgetNoLoss')}
        variant="informational"
        testId="lost-is-budget-icon"
      />
    )
  }

  return null
}
